import { DateRangePreset } from '../Interfaces/date-range-preset.interface';

export const DATE_RANGE_PRESETS_PANEL_CLASS = 'av-date-range-panel--presets';

export const DATE_RANGE_PRESETS: ReadonlyArray<DateRangePreset> = [
  { id: 'maximum', labelKey: 'app.reports.allDemands.filters.presets.maximum' },
  { id: 'last12Months', labelKey: 'app.reports.allDemands.filters.presets.last12Months' },
  { id: 'last3Months', labelKey: 'app.reports.allDemands.filters.presets.last3Months' },
  { id: 'last30Days', labelKey: 'app.reports.allDemands.filters.presets.last30Days' },
  { id: 'last7Days', labelKey: 'app.reports.allDemands.filters.presets.last7Days' },
  { id: 'thisMonth', labelKey: 'app.reports.allDemands.filters.presets.thisMonth' },
];

export const DATE_RANGE_PRESET_MONTHS = { last12Months: 12, last3Months: 3 } as const;

export const DATE_RANGE_PRESET_DAYS = { last30Days: 30, last7Days: 7 } as const;
